import React from "react";
import { blackrock, jpmorgan, fidelity, riverfront, wisdomtree, raymondjames, commonDisclosure } from "./disclosures";
import { TENANT } from "../../utils/constants";

import "./Footer.scss";

export interface FooterProps {
    tenant: string;
}

const Footer: React.FunctionComponent<FooterProps> = (props) => {
    const handleDisclosure = () => {
       let current = (commonDisclosure);
        switch (props.tenant) {
              case TENANT.WISDOMTREE:
                current = wisdomtree;
              break;
              case TENANT.RIVERFRONT:
                current = riverfront;
              break;
              case TENANT.BLACKROCK:
                current = blackrock;
              break;
              case TENANT.FIDELITY:
                current = fidelity;
              break;
              case TENANT.JPMORGAN:
                current = jpmorgan;
              break;
              case TENANT.RAYMONDJAMES:
                current = raymondjames;
              break;
          }
          return current
    }
  return (
    <div className={`${props.tenant}-footer`} {...props}>
     <div className={`new-footer ${props.tenant !== TENANT.FOCUS && props.tenant !== TENANT.BLACKROCK ? "black-bg" : ""}`}>
         <div className="row">
             <div className="col-md-6 col-sm-6">
              Copyright © {new Date().getFullYear()} 55IP. All rights reserved
             </div>
             { props.tenant !== TENANT.RAYMONDJAMES ? <div className="col-md-6 col-sm-6" style={{textAlign: "right"}}>
                 <div className="row" style={{paddingBottom: "10px", paddingRight:"10px", float: "right"}}>
                     <span className="glyphicon glyphicon-envelope"></span><a style={{fontWeight:"inherit"}} href="mailto:info@55-ip.com">info@55-ip.com</a>
                     <span className="glyphicon glyphicon-earphone"></span><a style={{fontWeight:"inherit"}} href="tel:617.960.9559">617.960.9559</a>
                 </div>
             </div> : "" }
         </div>
        {handleDisclosure()}
     </div>
    </div>
  );
};

export default Footer;
